var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserPro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1643 10.0227C20.1643 7.1226 17.8045 4.76279 14.9044 4.76279C12.0043 4.76279 9.64453 7.1226 9.64453 10.0227C9.64453 12.9228 12.0043 15.2826 14.9044 15.2826C17.8045 15.2826 20.1643 12.9228 20.1643 10.0227ZM14.9044 13.4966C12.9889 13.4966 11.4306 11.9382 11.4306 10.0227C11.4306 8.10716 12.9889 6.54883 14.9044 6.54883C16.82 6.54883 18.3783 8.10716 18.3783 10.0227C18.3783 11.9382 16.82 13.4966 14.9044 13.4966Z",
    fill: "#F7F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0207 22.8197H6.40006C6.40453 19.9628 8.73085 17.6402 11.5885 17.6402H16.0782C16.5775 16.9302 17.2116 16.3222 17.9439 15.8541H11.5885C7.74257 15.8541 4.61401 18.9827 4.61401 22.8286V23.7127C4.61401 24.2054 5.01439 24.6058 5.50704 24.6058H15.6815C15.3802 24.0528 15.1547 23.453 15.0207 22.8197Z",
    fill: "#F7F7F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5025 15.7083C18.3412 15.7083 15.7693 18.2802 15.7693 21.4415C15.7693 24.6028 18.3412 27.1747 21.5025 27.1747C24.6638 27.1747 27.2357 24.6028 27.2357 21.4415C27.2357 18.2802 24.6638 15.7083 21.5025 15.7083ZM24.9674 21.309L23.7715 22.4744L24.0536 24.1206C24.1012 24.3981 23.9873 24.6787 23.7596 24.8439C23.6309 24.9377 23.4783 24.9853 23.325 24.9853C23.2074 24.9853 23.0891 24.957 22.9812 24.9005L21.5032 24.1235L20.0253 24.9005C19.776 25.0314 19.4746 25.0099 19.2461 24.8439C19.0184 24.6787 18.9045 24.3981 18.9522 24.1206L19.2342 22.4744L18.0383 21.309C17.8366 21.1126 17.7645 20.8186 17.8508 20.5507C17.9378 20.2828 18.1693 20.0878 18.4476 20.0476L20.1005 19.8073L20.8394 18.31C20.9637 18.0577 21.2212 17.8977 21.5025 17.8977C21.7838 17.8977 22.0413 18.0577 22.1656 18.31L22.9045 19.8073L24.5574 20.0476C24.8357 20.0878 25.0672 20.2835 25.1542 20.5507C25.2413 20.8186 25.1684 21.1126 24.9667 21.309H24.9674Z",
    fill: "url(#user_pro_svg__paint0_linear_241_510)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "user_pro_svg__paint0_linear_241_510",
    x1: 15.7693,
    y1: 21.4415,
    x2: 27.2357,
    y2: 21.4415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4690FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CD4F2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPro);
export default __webpack_public_path__ + "static/media/user_pro.1569a93f92f615388f083708a14a7ce6.svg";
export { ForwardRef as ReactComponent };